<template>
  <div class="side_box">
    <div
      class="contribute_btn"
      @click="toUpload"
      v-if="$store.state.gameType != 2"
    >
      <strong>+</strong>投稿攻略
    </div>
    <div class="all_intro" @click="$router.push({ path: './detailPage' })">
      全部攻略
    </div>
    <i class="mecha_btn" @click="$router.push({ path: './painting' })"></i>
    <component
      v-for="(item, index) in componentsList"
      :key="index"
      :is="item.type"
      :title="item.title"
      :list="item.list"
    ></component>
    <upFllow />
  </div>
</template>

<script>
import get from '@/api/get';
import tip1Module from './childcomponents/tip1Module.vue';
import tip2Module from './childcomponents/tip2Module.vue';
import upFllow from './childcomponents/upFllow.vue';
export default {
  components: { tip1Module, tip2Module, upFllow },
  data() {
    return {
      componentsList: [] //type:2 tip1Module  5 tip2Module
    };
  },
  computed: {},
  watch: {
    '$store.state.token': function () {
      if (this.$store.state.token) {
        this.getPageInfo();
      }
    }
  },
  methods: {
    toUpload() {
      if (this.$store.state.loginStatus == 0) {
        this.$store.commit('changeLoginShow', true);
      } else {
        if (this.$store.state.postingFlag) {
          this.$router.push({
            name: 'rich2',
            query: {
              // subjectName: this.topic.subjectName,
              // id: this.topic.id,
              // subjectType: this.topic.subjectType,
            }
          });
        } else {
          Toast('功能维护中，暂不支持发帖');
        }
      }
    },
    getPageInfo() {
      get.getGlGameintro({ locate: 'f_gl_right' }).then((res) => {
        res.data.data.forEach((item) => {
          let obj = {};
          obj.title = item.ftrName;
          switch (item.vmode) {
            case 2:
              obj.type = 'tip1Module';
              obj.list = item.topics.map((child) => {
                return {
                  id: child.id,
                  title: child.title
                };
              });
              break;
            case 5:
              obj.type = 'tip2Module';
              obj.list = item.topics.map((child) => {
                return {
                  id: child.id,
                  title: child.title,
                  src: child.thumbnail
                };
              });
              break;
          }
          this.componentsList.push(obj);
        });
      });
    }
  },
  created() {
    if (this.$store.state.token) {
      this.getPageInfo();
    }
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
.gl .side_box {
  width: 3.5rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: -3.9rem;
  top: 0;
  .contribute_btn,
  .all_intro {
    width: 3.5rem;
    height: 0.7rem;
    background: #23323d;
    box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #ffffff;
    font-size: 0.24rem;
    margin-bottom: 0.2rem;
    cursor: pointer;
    strong {
      margin-right: 0.1rem;
    }
  }
  .all_intro {
    background: #8a98a4;
  }
  .mecha_btn {
    width: 3.5rem;
    height: 1.59rem;
    background: url('~@/assets/img/gl/gameIntro/mecha.jpg');
    background-size: 100% 100%;
    margin-bottom: 0.2rem;
    cursor: pointer;
  }
}
</style>